import { render, staticRenderFns } from "./ctcp.vue?vue&type=template&id=08b5bbdd&"
import script from "./ctcp.vue?vue&type=script&lang=js&"
export * from "./ctcp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports